import { render, staticRenderFns } from "./SidebarSubmenuItem.vue?vue&type=template&id=22bfce6c&scoped=true&"
import script from "./SidebarSubmenuItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarSubmenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarSubmenuItem.vue?vue&type=style&index=0&id=22bfce6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bfce6c",
  null
  
)

export default component.exports